module.exports = __webpack_public_path__ + "static/media/wrl-road-america-logo@2x.0f58bea5.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/wrl-road-america-logo@2x.png
// module id = 1220
// module chunks = 0